import agentFinder from './agentFinder';

/**
 * Resolves agent types to display data using agentFinder.
 * Uses playbook-specific descriptions when provided via playbookConfig.agentDescriptions.
 * @param {string[]} agentTypes - Array of agent type values (e.g. ['rag', 'pollingAgent', 'qualification'])
 * @param {{ agentDescriptions?: { [agentValue: string]: string } } | null} [playbookConfig] - Optional playbook config with agentDescriptions overrides
 * @returns {Array<{ name: string, description?: string, value: string, icon?: string }>}
 */
export default function getPlaybookAgentsFromTypes(agentTypes, playbookConfig = null) {
  if (!Array.isArray(agentTypes) || agentTypes.length === 0) return [];

  const agentDescriptions = playbookConfig?.agentDescriptions ?? {};

  return agentTypes
    .map(type => agentFinder(type))
    .filter(Boolean)
    .map(agent => ({
      name: agent.name,
      description: agentDescriptions[agent.value] ?? agent.description,
      value: agent.value,
      icon: agent.icon,
    }));
}
